// src/pages/ReturnsPage.js
import React from 'react';
import { FaEnvelope } from 'react-icons/fa';

export default function ReturnsPage() {
  return (
    <div className="container" style={{ maxWidth: '800px', margin: '40px auto', padding: '20px' }}>
      <h1 style={{ marginBottom: '30px', color: 'var(--primary)' }}>Kthimet</h1>
      
      <div style={{ background: '#f8f9fa', padding: '30px', borderRadius: '8px' }}>
        <p style={{ fontSize: '16px', lineHeight: '1.6', marginBottom: '20px' }}>
          Për çdo kthim, ju lutem na shkruani në email:
        </p>
        
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <a 
            href="mailto:orendiononline@gmail.com"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '10px',
              background: '#ea4335',
              color: 'white',
              padding: '12px 24px',
              borderRadius: '8px',
              textDecoration: 'none',
              fontSize: '16px',
              fontWeight: 'bold'
            }}
          >
            <FaEnvelope /> orendiononline@gmail.com
          </a>
        </div>
        
        <p style={{ fontSize: '16px', lineHeight: '1.6' }}>
          Duke na dërguar foton e produktit, ekipi ynë do t'ju kontaktojë në telefon.
        </p>
      </div>
    </div>
  );
}